import {
  ApplicationQuestion,
  CommonQuestionKeys,
  FieldType,
  KCSMBIDACustomQuestionKeys,
  TextInputType,
} from '@bybeam/platform-types';
import { YesNoOptions } from '@platform-ui/application/utils/index.js';
import { eq } from '../../../ast/utils.js';

type ExtractedCommonQuestionKeys = Extract<CommonQuestionKeys, CommonQuestionKeys.AFFIRMATION>;

export const QUESTIONS: {
  [key in ExtractedCommonQuestionKeys | KCSMBIDACustomQuestionKeys]: ApplicationQuestion;
} = {
  [KCSMBIDACustomQuestionKeys.CAN_COMMIT_TO_SAVING]: {
    key: KCSMBIDACustomQuestionKeys.CAN_COMMIT_TO_SAVING,
    copy: {
      title: 'Can you commit to saving a minimum of $2,500 over a four-month period?',
    },
    fields: [
      {
        type: FieldType.RadioList,
        key: 'canCommitToSaving.affirmation',
        options: YesNoOptions,
      },
    ],
  },
  [KCSMBIDACustomQuestionKeys.SEE_ANY_CHALLENGES_MEETING_SAVINGS_COMMITMENTS]: {
    key: KCSMBIDACustomQuestionKeys.SEE_ANY_CHALLENGES_MEETING_SAVINGS_COMMITMENTS,
    copy: {
      title: 'Do you see any challenges with meeting the savings commitments?',
    },
    fields: [
      {
        type: FieldType.RadioList,
        key: 'seeAnyChallengesMeetingSavingsCommitments.affirmation',
        options: YesNoOptions,
      },
      {
        type: FieldType.Text,
        inputType: TextInputType.Text,
        key: 'seeAnyChallengesMeetingSavingsCommitments.explanation',
        copy: 'Explanation',
        dynamicLogic: eq('seeAnyChallengesMeetingSavingsCommitments.affirmation', 'yes'),
        props: {
          multiline: true,
          rows: 5,
          characterCounter: { max: 500 },
        },
      },
    ],
  },
  [CommonQuestionKeys.AFFIRMATION]: {
    key: CommonQuestionKeys.AFFIRMATION,
    copy: { title: 'Please confirm this statement:' },
    fields: [
      {
        type: FieldType.Checkbox,
        key: CommonQuestionKeys.AFFIRMATION,
        copy: 'I affirm the above to be true and accurate.  I understand that financial statements, references, an interview and/or site visit may be necessary for the purposes of determining grant finalists.',
      },
    ],
  },
};
